// Policy configuration for legal consent capture.
//
// `policy_hash` is the SHA-256 of each document's VISIBLE TEXT (scripts/styles/tags
// stripped, whitespace collapsed), precomputed offline — NOT a hash of raw HTML
// (which contains a volatile per-request nonce) and NOT computed at runtime.
//
// IMPORTANT: when a document changes, bump BOTH `version` (to the new "Last Updated"
// date, ISO) AND `hash` — otherwise an updated policy will NOT trigger a fresh consent
// record (the backend de-dupes on version). Recompute the hash with:
//
//   curl -sL "<url>" \
//     | perl -0777 -pe 's/<script.*?<\/script>//gis; s/<style.*?<\/style>//gis' \
//     | perl -0777 -pe 's/<[^>]+>/ /g' \
//     | perl -0777 -pe 's/\s+/ /g' \
//     | perl -pe 's/^\s+|\s+$//g' \
//     | shasum -a 256
//
// Only terms & privacy are document-backed; marketing has no config.
export const LEGAL_POLICIES = {
  terms: {
    url: "https://pioneera.io/apps/same-item-multiple-boards/terms-of-use",
    version: "2024-07-21",
    hash: "72d22a65d93e2af7a3640835624b391d5340fd746d8a84fc28c9765a397d3d4c",
  },
  privacy: {
    url: "https://pioneera.io/apps/same-item-multiple-boards/privacy-policy",
    version: "2024-08-26",
    hash: "33500f47db006fc43e3ec3589182814ca6521da05409423da45bcc0c35daf140",
  },
} as const;

// `source` values identify the capture surface in the audit log.
export const CONSENT_SOURCE_ONBOARDING = "onboarding_legal";
export const CONSENT_SOURCE_APP_GATE = "app_consent_gate";

// Keep in sync with package.json "version".
export const CONSENT_APP_VERSION = "0.0.1";
